import { useScrollPosition } from 'myt-react-snippets';
import { selectEl } from 'Common/Utils';

export const useScrollSpy = (
	scrollSpyRegistry = [],
	url = '',
	ancestor,
	prefixTop = 99
) => {
	useScrollPosition(({ current }) => {
		scrollSpyRegistry.forEach((id) => {
			const spying = document.getElementById(id);
			const anchor = selectEl(`${ancestor} a[href="${url}#${id}"]`.trim());
			if (!spying || !anchor) return;

			const { y, height } = spying.getBoundingClientRect();
			const windowPos = Math.floor(current.y + prefixTop);
			const targetPos = Math.floor(current.y + y);
			const targetViewPos = targetPos + height;
			const hasActive = anchor.classList.contains('active');
			if (!hasActive && windowPos <= targetViewPos && windowPos >= targetPos)
				anchor.classList.add('active');
			else if (
				hasActive &&
				!(windowPos <= targetViewPos && windowPos >= targetPos)
			)
				anchor.classList.remove('active');
		});
	});
};
